import React, { useEffect, useState } from "react";
import CustomDataTable from "../../Componant/CustomDataTable";
import { FaRegEdit } from "react-icons/fa";
import { FiSettings, FiCopy } from "react-icons/fi";
import { Tooltip } from "@mui/material";
import axios from "../../customAxios";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material"; // Material UI components

const ManageAppContent = () => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewContent, setPreviewContent] = useState("");
  const [copiedItem, setCopiedItem] = useState(null);
  const [data, setData] = useState([]);
  const [allSupportedObjects, selAllSupportedObjects] = useState({});
  const [openForm, setOpenForm] = useState(false); // State to manage modal form visibility
  const [applicationTypes, setApplicationTypes] = useState([]);
  const [authTypes, setAuthTypes] = useState([]);
  const [applicationDynamicFields, setApplicationDynamicFields] = useState({});
  const [authDynamicFields, setAuthDynamicFields] = useState({});
  const [formData, setFormData] = useState({
    appName: "",
    appType: "",
    oauthType: "",
    dynamicFields: {},
    authDynamicFields: {},
  });

  const getApplicationTypeKeys = (applicationTypes) => {
    return applicationTypes.map((type) => Object.keys(type)[0]);
  };
  const changeDynamicFieldStruture = (a) => {
    var result = {};

    a.forEach((item) => {
      Object.assign(result, item);
    });

    return result;
  };
  useEffect(() => {
    axios
      .get(
        `/registerscimapp/registerfortenant/${process.env.REACT_APP_REGISTERED_APP_NAME}/getAllApplications`
      )
      .then((res) => {
        setData(res.data?.Applications);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {}, [data]);

  const handleDynamicFieldChange = (fieldName, value) => {
    setFormData((prev) => ({
      ...prev,
      dynamicFields: {
        ...prev.dynamicFields,
        [fieldName]: value,
      },
    }));
  };

  const handleStatusToggle = (ApplicationID) => {
    setData((prevData) => {
      const updatedData = prevData.map((row) =>
        row.ApplicationID === ApplicationID
          ? { ...row, active: !row.active }
          : row
      );
      return updatedData; // Trigger a re-render with the updated data
    });
  };

  const handlePreviewOpen = (content) => {
    setPreviewContent(content);
    setPreviewOpen(true);
  };

  const handlePreviewClose = () => {
    setPreviewOpen(false);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    console.log(text);
    setCopiedItem(text);
    setTimeout(() => setCopiedItem(null), 2000); // Reset tooltip after 2 seconds
  };
  const getAllSupportedObjects = () => {
    axios
      .get(
        `/registerscimapp/registerfortenant/${process.env.REACT_APP_REGISTERED_APP_NAME}/getAllSupportedObjects`
      )
      .then((res) => {
        selAllSupportedObjects(res.data);
        setApplicationTypes(getApplicationTypeKeys(res.data?.applicationType));
        setAuthTypes(getApplicationTypeKeys(res.data?.oauthType));
        setApplicationDynamicFields(
          changeDynamicFieldStruture(res.data?.applicationType)
        );
        setAuthDynamicFields(changeDynamicFieldStruture(res.data?.oauthType));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleFormOpen = () => {
    getAllSupportedObjects();
    setOpenForm(true);
  };

  const handleFormClose = () => {
    setFormData({appName: "",
      appType: "",
      oauthType: "",
      dynamicFields: {},
      authDynamicFields: {}})
    setOpenForm(false);
  };

  const handleInputChange = (key, value) => {
    setFormData((prev) => {
      const updatedData = {
        ...prev,
        [key]: value,
      };

      if (key === "appType") {
        updatedData.dynamicFields = {};
      }

      if (key === "oauthType") {
        updatedData.authDynamicFields = {};
      }

      return updatedData;
    });
  };

  const renderDynamicFields = (fieldType) => {
    function convertToReadableText(text) {
      return text
        .replace(/([a-z])([A-Z])/g, "$1 $2") // for camelCase
        .replace(/_/g, " ") // for snake_case
        .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize the first letter of each word
    }

    const fields =
      fieldType === "application"
        ? applicationDynamicFields?.[formData.appType] || []
        : authDynamicFields?.[formData.oauthType] || [];

    return fields.map((field) => {
      return (
        <TextField
          key={field}
          label={convertToReadableText(field)}
          variant="outlined"
          fullWidth
          margin="normal"
          value={
            fieldType === "application"
              ? formData.dynamicFields[field] || ""
              : formData.authDynamicFields[field] || ""
          }
          onChange={(e) =>
            handleDynamicFieldChange(
              field,
              e.target.value,
              `${fieldType}DynamicFields`
            )
          }
        />
      );
    });
  };

  const handleFormSubmit = () => {
    console.log(formData);
    setOpenForm(false);
  };

  const CopyCell = ({ text }) => (
    <Tooltip title={copiedItem === text ? "Copied!" : text} arrow>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "250px",
        }}
      >
        <span
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "calc(100% - 30px)",
          }}
        >
          {text}
        </span>
        <FiCopy
          size={16}
          style={{
            cursor: "pointer",
            color: "#1976d2",
            minWidth: "16px",
          }}
          onClick={() => handleCopy(text)}
        />
      </div>
    </Tooltip>
  );

  const columns = [
    {
      name: "Application Name",
      selector: (row) => row.ApplicationName,
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => row.ApplicationType,
      sortable: true,
    },
    {
      name: "API Token",
      cell: (row) => <CopyCell text={row.APIToken} />,
    },
    {
      name: "App URL",
      cell: (row) => <CopyCell text={row.SCIMURL} />,
    },
    // {
    //   name: "Active",
    //   cell: (row) => (
    //     <button
    //       onClick={() => handleStatusToggle(row.ApplicationID)}
    //       style={{
    //         backgroundColor: row.active ? "#4CAF50" : "#F44336", // Green & Red shades
    //         color: "white",
    //         border: "none",
    //         padding: "5px 10px",
    //         borderRadius: "5px",
    //         cursor: "pointer",
    //         boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    //       }}
    //     >
    //       {row.active ? "Active" : "Inactive"}
    //     </button>
    //   ),
    // },
    {
      name: "Actions",
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <FaRegEdit
            onClick={() => console.log("Edit", row.ApplicationID)}
            size={20}
          />
          <FiSettings
            onClick={() => console.log("Setting", row.ApplicationID)}
            size={20}
          />
        </div>
      ),
    },
  ];

  return (
    <div>
      {/* Preview Modal */}
      {previewOpen && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "#fff",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
          }}
        >
          <h3>Preview</h3>
          <pre>{previewContent}</pre>
          <button onClick={handlePreviewClose}>Close</button>
        </div>
      )}

      <div
        style={{ display: "flex", justifyContent: "end", margin: "8px 0px" }}
      >
        <button
          onClick={handleFormOpen}
          style={{
            borderRadius: "7px",
            background: "var(--primary-color)",
            color: "white",
            border: "none",
            padding: "8px 16px",
            fontSize: "1em",
          }}
        >
          Register Application
        </button>
      </div>
<Dialog open={openForm} onClose={handleFormClose} fullWidth maxWidth="sm">
  <DialogTitle>Register New Application</DialogTitle>
  <DialogContent>
    <TextField
      label="Application Name"
      variant="outlined"
      fullWidth
      margin="normal"
      value={formData.appName}
      onChange={(e) => handleInputChange("appName", e.target.value)}
    />
    <Grid container spacing={2} margin="normal">
      {/* Application Type Dropdown */}
      <Grid item xs={6}>
        <FormControl fullWidth>
          <InputLabel>Application Type</InputLabel>
          <Select
            value={formData.appType}
            onChange={(e) => handleInputChange("appType", e.target.value)}
            label="Application Type"
          >
            {applicationTypes?.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {formData.appType && renderDynamicFields("application")}
      </Grid>

      {/* Auth Type Dropdown */}
      <Grid item xs={6}>
        <FormControl fullWidth>
          <InputLabel>Auth Type</InputLabel>
          <Select
            value={formData.oauthType}
            onChange={(e) => handleInputChange("oauthType", e.target.value)}
            label="Auth Type"
          >
            {authTypes?.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {formData.oauthType && renderDynamicFields("auth")}
      </Grid>
    </Grid>

    {/* Dynamic Fields */}
    
  
  </DialogContent>
  <DialogActions>
    <Button onClick={handleFormClose} color="secondary">
      Cancel
    </Button>
    <Button
      onClick={handleFormSubmit}
      color="primary"
      variant="contained"
    >
      Submit
    </Button>
  </DialogActions>
</Dialog>


      {/* Custom DataTable */}
      <CustomDataTable
        title={"Applications Management"}
        columns={columns}
        data={data}
      />
    </div>
  );
};

export default ManageAppContent;
